import { Component, inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, RouterOutlet } from '@angular/router';

import { getMenuItems } from './taas-menuitems';
import { TaasUserService } from './core/services/taas-user-service.service';
import { TaasMenuItem, TaasUserDetails } from 'utimaco-common-ui-angular';
import { TaasMainLayoutComponent, TaasHiddenVersionInfoComponent, TaasToastrComponent } from 'utimaco-common-ui-angular';
import Keycloak from 'keycloak-js';

import { environment } from '@env/environment';

//NOTE: to be able to import json like this, make sure to add these settings to your ts config:
// "resolveJsonModule": true,
// "allowSyntheticDefaultImports": true,
import appPackageJson from '../../package.json';
import commonUiPackageJson from 'utimaco-common-ui-angular/package.json';

@Component({
  selector: 'app-root',
  imports: [TaasMainLayoutComponent, TaasHiddenVersionInfoComponent, RouterOutlet, TaasToastrComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})

export class AppComponent implements OnInit {
  private keycloak = inject(Keycloak);

  private router = inject(Router);
  private taasUserService = inject(TaasUserService);

  activeRoute: string = "/";
  taasMenuItems: TaasMenuItem[] = [];
  commonUiLibVersion: string = commonUiPackageJson.version;
  appVersion: string = appPackageJson.version;
  supportedLanguages: string[] = ['de-DE','en-US','sv-SE','es-ES'];

  public currentUser: TaasUserDetails = {
    givenName: "",
    familyName: "",
    email: "",
    initials: "",
    roles: []
  };

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.url;
      }
    });

    this.taasUserService.getCurrentUserDetails().then((taasUserDetails) => {
      this.currentUser = taasUserDetails;
      this.taasMenuItems.splice(0, this.taasMenuItems.length, ...getMenuItems(this.currentUser.roles!));
    });
  }

  handleRouteUpdateRequest(path: string) {
    if(path.startsWith("http")){
      window.open(path, "_blank");
    } else 
      this.router.navigateByUrl(path);
  }

  navigateHome() {
    window.open(environment.taasPortalFrontendUrl);
  }

  performLogout() {
    this.keycloak?.logout();
  }

  handleUserContextMenuEvent(event: string) {
    switch (event) {
      case "logout":
        this.performLogout();
        break;
      case "showOwnProfile":
        console.log("TODO: show own profile");
        break;
      default:
        console.log("Unsupported user info context event received: ", event);
        break;
    }
  }
}
